import { useState, useEffect } from 'react'

const useAudio = (url: string): [boolean, () => void] => {
	const [audio] = useState(new Audio(url))
	const [playing, setPlaying] = useState(false)

	const toggle = () => setPlaying(!playing)

	useEffect(() => {
		// eslint-disable-next-line no-unused-expressions
		playing ? audio.play() : audio.pause()
	}, [audio, playing])

	useEffect(() => {
		audio.addEventListener('ended', () => setPlaying(false))
		return () => {
			audio.removeEventListener('ended', () => setPlaying(false))
			audio.pause()
		}
	}, [audio])

	return [playing, toggle]
}

export default useAudio
